var map = {
	"./CrossSvg": 9993,
	"./CrossSvg.vue": 9993,
	"./barDecoration.png": 272,
	"./logoBrightDesktop.png": 1178,
	"./logoBrightMobile.png": 4564,
	"./logoBrightTablet.png": 5006,
	"./logoDark.png": 8208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5991;